
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.857 13.96H1.143A1.145 1.145 0 010 12.817V9.845h.457v2.972a.686.686 0 00.686.686h13.714a.686.686 0 00.686-.686V4.13a.686.686 0 00-.686-.686H1.143a.686.686 0 00-.686.686v4.8H0v-4.8a1.144 1.144 0 011.143-1.143h13.714A1.144 1.144 0 0116 4.131v8.686a1.145 1.145 0 01-1.143 1.143z","fill":"#6C6C6C"}}),_c('path',{attrs:{"d":"M13.715 5.045h2.057v.458h-2.057v-.458zM.229 5.045h12.57v.458H.23v-.458zM.229 7.103H15.77v.457H.23v-.457zM1.371 12.36h4.8v.457h-4.8v-.457zM1.371 11.217h2.514v.457H1.371v-.457z","fill":"#6C6C6C"}})])
          )
        }
      }
    